import React from 'react';
import { Text, Header, BackButton, PageCardLarge, Button } from 'ui';
import { useAuth, useUnassignedPages, updateCampaign, updatePage } from 'api';
import { useHistory, useParams, Redirect } from 'react-router-dom';
import { lightBlue } from 'config/colors';
import "./index.css";

export default function AddPage(props) {
  const history = useHistory();
  const auth = useAuth();
  const {campaignId} = useParams();
  const pages = useUnassignedPages(auth ? auth.user.companyId : null);
  
  async function add(page) {
    updatePage(auth.user.companyId, page.id, {campaignId});
    updateCampaign(auth.user.companyId, campaignId, {pageId:page.id});
    history.push(`view`);
  }
  
  if(!pages) {
    return null;
  }
  
  if(pages.length === 0) {
    return <Redirect to="create-page"/>;
  } 
  
  return (
    <div>
      <Header>
        <BackButton/> <Text large light style={{flex:1}}>Select a Landing Page</Text>
        <Button to="create-page" label="CREATE LANDING PAGE" small white style={{backgroundColor:lightBlue}}/>
      </Header>
      <div className="campaign-addpage-grid">
        {pages.map(page => <PageCardLarge key={page.id} {...page} onClick={() => add(page)}/>)}
      </div>
    </div>
  );
}